import { IconCardWalky } from "../iconCardWalky";
import styles from "./styles.module.scss";

export const OptionsWithoutBackground = ({
  data,
  background,
  onClick,
  title,
  hint,
  isWalky = false,
}) => {
  return (
    <div className={styles.container}>
      {isWalky ? (
        <p className={styles.titleWalky}>{title}</p>
      ) : (
        <h2>{title}</h2>
      )}
      <div className={styles.image}>
        <img src={background} alt="bg" />
      </div>
      <div className={styles.cards}>
        {data.map((item) => (
          <IconCardWalky
            img={item.emoji}
            onClick={() => onClick(item)}
            key={item.value}
            className={styles.card}
            title={item.displayValue}
          />
        ))}
        {hint && <div className={styles.hint}>{hint}</div>}
      </div>
    </div>
  );
};
